import React, {createContext, useContext, useState, useRef, useMemo, useEffect} from 'react'
import {useStickyState} from './sticky-context'

const HeaderContext = createContext()

export const HeaderProvider = ({children}) => {
    const lastScrollY = useRef(0)
    const [shouldShowSticky, setShouldShowSticky] = useState(false)
    const [headerHeight, setHeaderHeight] = useState(0)
    const headerRef = useRef(null)
    const [scrollDir, setScrollDir] = useState('up')
    const [scrollChange, setScrollChange] = useState(0)
    const {pdpStickyButtonActive} = useStickyState()
    const [shouldShowHeader, setShouldShowHeader] = useState(true)
    const [category, setCategory] = useState(null)
    const [product, setProduct] = useState(null)

    useEffect(() => {
        const handleScroll = () => {
            const currentY = window.scrollY

            if (Math.abs(currentY - lastScrollY.current) < 5) return

            if (currentY > lastScrollY.current) {
                setScrollDir('down')
            } else {
                setScrollDir('up')
            }

            lastScrollY.current = currentY

            setScrollChange(currentY)
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    useEffect(() => {
        setShouldShowHeader(scrollDir === 'up' || (!shouldShowSticky && !pdpStickyButtonActive))
    }, [scrollChange])

    const contextValue = useMemo(
        () => ({
            headerRef,
            shouldShowSticky,
            setShouldShowSticky,
            headerHeight,
            setHeaderHeight,
            shouldShowHeader,
            setShouldShowHeader,
            category,
            setCategory,
            product,
            setProduct
        }),
        [shouldShowSticky, headerHeight, shouldShowHeader, category, product]
    )

    return <HeaderContext.Provider value={contextValue}>{children}</HeaderContext.Provider>
}

export const useHeaderContext = () => {
    const context = useContext(HeaderContext)
    if (!context) {
        throw new Error('useHeaderContext must be used within HeaderProvider')
    }
    return context
}
